import React, { useState } from 'react';
import { ImageGalleryViewer } from './ImageGalleryViewer';
import './ImageViewer.css';

interface ImageViewerProps {
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Clickable image thumbnail that opens a fullscreen viewer with zoom + rotate.
 * Click stops propagation so wrapping inside clickable parents (cards, modals) is safe.
 * Usage: <ImageViewer src={url} alt="Solution" className="my-img" />
 *
 * The single-image case of `ImageGalleryViewer` — which owns the overlay, and
 * hides its page rail and arrows at a count of one.
 */
export function ImageViewer({ src, alt = 'Image', className, style }: ImageViewerProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`image-viewer-thumb ${className || ''}`}
        style={style}
        loading="lazy"
        onClick={(e) => { e.stopPropagation(); setIsOpen(true); }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); setIsOpen(true); } }}
      />
      {isOpen && (
        <ImageGalleryViewer images={[{ src, alt }]} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
}
